/* ============================================================================
   RZLD RFI Form — Phase 4A v1.0 (2026-10-14)
   Frontend validation + loading state + basic UX
   Backend integration (Klaviyo / Shopify contact) P0 paused per 东家 instruction
   ============================================================================ */

(function() {
  'use strict';

  function initRfiForms() {
    const forms = document.querySelectorAll('.rzld-rfi-form form');
    if (!forms.length) return;

    forms.forEach(function(form) {
      // Mark required fields
      const requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');
      requiredFields.forEach(function(field) {
        field.addEventListener('invalid', handleInvalid);
        field.addEventListener('input', clearError);
      });

      // Form submit handler
      form.addEventListener('submit', handleSubmit);
    });
  }

  function handleInvalid(event) {
    event.preventDefault();
    const field = event.target;
    field.classList.add('rzld-rfi__field--error');
    field.focus();
  }

  function clearError(event) {
    event.target.classList.remove('rzld-rfi__field--error');
  }

  function handleSubmit(event) {
    const form = event.target;
    const submitBtn = form.querySelector('.rzld-rfi__submit');
    if (!submitBtn) return;

    // Browser will validate required fields automatically
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }

    // Loading state
    const originalText = submitBtn.textContent;
    submitBtn.textContent = 'Submitting...';
    submitBtn.disabled = true;
    submitBtn.classList.add('rzld-rfi__submit--loading');

    // Re-enable after 3s in case form action fails / is paused
    // (Phase 4A: backend integration paused, so form may not actually submit)
    setTimeout(function() {
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
      submitBtn.classList.remove('rzld-rfi__submit--loading');
    }, 3000);
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRfiForms);
  } else {
    initRfiForms();
  }
})();
